import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  encryptUrlData,
  toAbsoluteUrl,
} from "../../helpers/Reusable";
import { Link } from "react-router-dom";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { setCookie } from "../../helpers/CookieComponent";

const MyLibrary = () => {
  ChangeTitle("My Library");
  const [mainMenu, setMainMenu] = useState("professional");
  const [libraryList, setLibraryList] = useState([]);

  // Library List API Call
  const viewLibraryList = async (type) => {
    const param = {
      type: type,
      offset: 0,
      limit: 0,
      sort: "",
      sortBy: "",
    };

    var response = await postData(
      "private/user/mylibrary",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setLibraryList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewLibraryList(mainMenu);
  }, [mainMenu]);

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">My library</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="relative z-[2] mb-[5%] w-max flex justify-evenly p-[2%] md:p-[1%] mx-auto rr-main-menu webinar-menu">
            <button
              className={
                mainMenu == "professional"
                  ? "order-box-active order-box"
                  : "order-box"
              }
              onClick={() => setMainMenu("professional")}
            >
              Professional
            </button>
            <button
              className={
                mainMenu == "students"
                  ? "order-box-active order-box"
                  : "order-box"
              }
              onClick={() => setMainMenu("students")}
            >
              Students
            </button>
          </div>
          <div>
            {libraryList.length > 0 && (
              <div className="lg:w-[75%] grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-y-[5rem] gap-x-[3rem] mx-auto sec-book-part2">
                {libraryList.map((data, i) => (
                  <div className="w-full">
                    <div className="flex flex-col gap-3 items-center md:items-start w-full h-full sbp2-box">
                      <Link
                        to={`/mylibrarydetail?gcc=${encryptUrlData({
                          validTill: data.validTill,
                        })}`}
                        onClick={() => {
                          setCookie("libraryId", data._id, {});
                          setCookie("l-currency", data.currency, {});
                        }}
                        className="w-full"
                      >
                        <img
                          className="w-full aspect-square object-cover rounded-[2rem]"
                          src={data.bookImage}
                          alt="Book Image"
                        />
                      </Link>
                      <Link
                        to={`/mylibrarydetail?gcc=${encryptUrlData({
                          validTill: data.validTill,
                        })}`}
                        onClick={() => {
                          setCookie("libraryId", data._id, {});
                          setCookie("l-currency", data.currency, {});
                        }}
                        className="library-title"
                      >
                        {data.title}
                      </Link>
                      <p className="library-tax">{data.tax || "UAE VAT"}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {libraryList.length == 0 && (
              <h1 className="w-full text-center no-found">No library found</h1>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MyLibrary;
